import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationPlanWorkFinanceAttributions(companyId, regulationId, stageId, planWorkId) {
	return dataTransferWrap(
		ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION]
			.getRegulationPlanWorkFinanceAttributions,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
			},
		}
	)
}

function createRegulationPlanWorkFinanceAttribution(
	companyId,
	regulationId,
	stageId,
	planWorkId,
	data
) {
	return dataTransferWrap(
		ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION]
			.createRegulationPlanWorkFinanceAttribution,
		{
			urlParams: {
				companyId,
				regulationId,
				stageId,
				planWorkId,
			},
			...data,
		}
	)
}

function getRegulationPlanWorkFinanceAttribution(
	companyId,
	regulationId,
	stageId,
	planWorkId,
	financeAttributionId
) {
	return dataTransferWrap(
		ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION]
			.getRegulationPlanWorkFinanceAttribution,
		{
			urlParams: {
				companyId,
				regulationId,
				stageId,
				planWorkId,
				financeAttributionId,
			},
		}
	)
}

function patchRegulationPlanWorkFinanceAttribution(
	companyId,
	regulationId,
	stageId,
	planWorkId,
	financeAttributionId,
	data
) {
	return dataTransferWrap(
		ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION]
			.patchRegulationPlanWorkFinanceAttribution,
		{
			urlParams: {
				companyId,
				regulationId,
				stageId,
				planWorkId,
				financeAttributionId,
			},
			...data,
		}
	)
}

function putRegulationPlanWorkFinanceAttribution(
	companyId,
	regulationId,
	stageId,
	planWorkId,
	financeAttributionId,
	data
) {
	return dataTransferWrap(
		ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION]
			.putRegulationPlanWorkFinanceAttribution,
		{
			urlParams: {
				companyId,
				regulationId,
				stageId,
				planWorkId,
				financeAttributionId,
			},
			...data,
		}
	)
}

function deleteRegulationPlanWorkFinanceAttribution(
	companyId,
	regulationId,
	stageId,
	planWorkId,
	financeAttributionId
) {
	return dataTransferWrap(
		ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION]
			.deleteRegulationPlanWorkFinanceAttribution,
		{
			urlParams: {
				companyId,
				regulationId,
				stageId,
				planWorkId,
				financeAttributionId,
			},
		}
	)
}

export default {
	getRegulationPlanWorkFinanceAttributions,
	getRegulationPlanWorkFinanceAttribution,
	patchRegulationPlanWorkFinanceAttribution,
	putRegulationPlanWorkFinanceAttribution,
	createRegulationPlanWorkFinanceAttribution,
	deleteRegulationPlanWorkFinanceAttribution,
}
